module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg7.04ce3825.jpg";